import { combineReducers } from 'redux';

import { connectRouter } from 'connected-react-router';
import dataSetsReducer from './dataSetsReducer';
import outgoingTargetsReducer from './outgoingTagertsReducer';
import errorReducer from './ErrorReducer';
import pilotageVolumeReducer from './pilotageVolumeReducer';
import refCampaignReducer from './refCampaignReducer';
import accountReducer from './AccountReducer';
import retryReducer from './RetryReducer';

const Reducers = (history) =>
  combineReducers({
    refCampaign: refCampaignReducer,
    dataSet: dataSetsReducer,
    outgoingTarget: outgoingTargetsReducer,
    pilotageVolume: pilotageVolumeReducer,
    account: accountReducer,
    retries: retryReducer,
    error: errorReducer,
    router: connectRouter(history),
  });

export default Reducers;
